module.exports = __webpack_public_path__ + "static/media/8771.686665dd.png";